export const REVENUE_REALITY_TAB_CONFIG = [
  { key: "revenue_reality", label: "Revenue Reality" },
  { key: "fixed_cost_viability", label: "Fixed Cost Viability" },
  { key: "product_sku_economics", label: "Product SKU Economics" },
  { key: "customer_lifetime_economics", label: "Customer Lifetime Economics" },
  { key: "growth_efficiency_channel_mix", label: "Growth Efficiency & Channel Mix" },
  { key: "margin_stability", label: "Margin Stability" },
  { key: "operations_readiness_confidence", label: "Operations Readiness" },
];
